import React from "react";

const NftCard = () => {
	return <div className="bg-white p-7">NftCard</div>;
};

export default NftCard;
